export default __webpack_public_path__ + "static/media/mad-ancient01.207e040c.png";